import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { minStringMessage, requiredString } from '@/utils/zodUtils';
import { passwordMinLengthValidation } from '@/utils/zodValidation/passwordMinLengthValidation';

export const PASSWORD_MIN_LENGTH = 6;

export const ChangePasswordFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      oldPassword: requiredString(t),
      newPassword: requiredString(t),
    })
    .strict()
    .refine((data) => passwordMinLengthValidation(data.newPassword, PASSWORD_MIN_LENGTH), {
      ...minStringMessage,
      path: ['newPassword'],
    });

export type ChangePasswordFormType = z.infer<ReturnType<typeof ChangePasswordFormSchema>>;
